import App from "./App";
import { socketURL, isProd } from "@/app.config.js";
import Socket from "@/utils/socket.js";
import dialogPlugin from "@/pages/globalMask/index.js";

// #ifndef VUE3
import Vue from "vue";
import "./uni.promisify.adaptor";
Vue.config.productionTip = false;
App.mpType = "app";
const app = new Vue({
  ...App,
});
app.$mount();
// #endif

// #ifdef VUE3
import { createSSRApp } from "vue";
import * as Pinia from "pinia";
// #ifndef H5
import pako from "pako";
// #endif
import i18n from "@/locale/index.js";
import utils from "@/utils/index.js";

uni.$ws = new Socket(socketURL);
uni.$u = utils;
// #ifdef H5
setTimeout(() => {
  uni.$pako = window.pako;
}, 0);
// #endif
// #ifndef H5
uni.$pako = pako;
// #endif

// 生产环境去掉打印
if (isProd) {
  console.log = () => {};
}

export function createApp() {
  const app = createSSRApp(App);
  app.use(Pinia.createPinia());
  app.use(i18n);
  app.use(dialogPlugin);
  app.config.globalProperties.$u = utils;
  return {
    app,
    Pinia,
  };
}
// #endif
